module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_elite.4d742213.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_elite.png
// module id = 1385
// module chunks = 11